import { createFileRoute } from "@tanstack/react-router";

import RewardsOverview from "@/components/Loyalty/RewardsOverview";

const Component = () => {
  const search = Route.useSearch();
  return <RewardsOverview tab={search.tab === "log" ? "log" : "rewards"} />;
};

export const Route = createFileRoute("/gym/$venueUuid/loyalty/rewards")({
  component: Component,
  validateSearch: (search: Record<string, unknown>): { tab?: "log" } =>
    search.tab === "log" ? { tab: "log" } : {},
});
